const SnapType = {
  Start: 'Start',
  Center: 'Center',
  End: 'End',
  Disabled: 'Disabled'
};

export default SnapType;
